<template>
  <v-layout class="auth-wrapper">
    <v-container fluid>
      <v-row class="fill-height" align="center" justify="center">
        <v-col class="py-6" cols="12" sm="8" md="6" lg="4" xl="3">
          <div class="d-flex align-center justify-center mb-6">
            <v-img
              :src="$settings?.profile?.logo"
              max-width="3rem"
              class="mr-4"
              contain
            />

            <span class="text-h5 font-weight-bold">
              {{ $settings.profile?.name }}
            </span>
          </div>

          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: "Auth",

  data() {
    return {
      recaptchaScript: null,
      recaptchaLoaded: false,
    };
  },

  mounted() {
    this.loadRecaptcha();
  },

  beforeDestroy() {
    this.hideRecaptchaBadge();

    if (this.recaptchaScript) {
      this.recaptchaScript.remove();
    }
  },

  methods: {
    loadRecaptcha() {
      if (window.grecaptcha || this.recaptchaLoaded) {
        this.recaptchaLoaded = true;
        this.showRecaptchaBadge();
        return;
      }

      this.recaptchaScript = document.createElement("script");
      this.recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`;
      this.recaptchaScript.async = true;
      this.recaptchaScript.defer = true;
      this.recaptchaScript.onload = () => {
        this.recaptchaLoaded = true;
        this.showRecaptchaBadge();
      };
      document.head.appendChild(this.recaptchaScript);
    },

    hideRecaptchaBadge() {
      const badge = document.querySelector(".grecaptcha-badge");
      if (badge) {
        badge.style.visibility = "hidden";
        badge.style.opacity = "0";
      }
    },

    showRecaptchaBadge() {
      const badge = document.querySelector(".grecaptcha-badge");
      if (badge) {
        badge.style.visibility = "visible";
        badge.style.opacity = "1";
      }
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
